import React from "react";
import { Button, Select, Form, Input, Switch, Popconfirm } from "antd";

const { Option } = Select;

class FormOne extends React.Component {
  userIdOnChange = (e) => {
    this.props.userIdOnChange(e);
  };
  formOneOnFinish = (e) => {
    this.props.formOneOnFinish(e);
  };
  formOneOnFinishFailed = (e) => {
    console.log(e, "formOneOnFinishFailed");
  };

  render() {
    const { userListGetData, formRef, dataOne } = this.props;

    const userOptions = userListGetData.map((d) => (
      <Option key={d._id}>
        {d.name} - {d.user_name} - {d.email}
      </Option>
    ));

    return (
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        ref={formRef}
        onFinish={this.formOneOnFinish}
        onFinishFailed={this.formOneOnFinishFailed}
        scrollToFirstError={true}
      >
        <Form.Item
          name="user_id"
          label="User"
          rules={[
            {
              required: true,
              message: "Please Enter User",
            },
          ]}
        >
          <Select
            showSearch
            allowClear={true}
            optionFilterProp="children"
            notFoundContent={null}
            placeholder="Enter User"
            onChange={this.userIdOnChange}
          >
            {userOptions}
          </Select>
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            {
              required: true,
              message: "Please Enter Email",
            },
          ]}
        >
          <Input
            placeholder="Enter Email"
            disabled={!dataOne || dataOne?.email ? true : false}
          />
        </Form.Item>

        <Form.Item
          label="Password Reset"
          name="password_reset"
          valuePropName="checked"
          style={{ display: "none" }}
        >
          <Switch />
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
          {process.env.REACT_APP_PLATFORM_TYPE === "GENERIC" ? (
            <Button
              type="primary"
              htmlType="submit"
              disabled={dataOne ? false : true}
            >
              {dataOne && dataOne.welcome_reset_status
                ? "Send Password Reset Link"
                : "Send Invitation"}
            </Button>
          ) : (
            <Popconfirm
              title="Are you sure this is a SM user account?"
              okText="Yes"
              cancelText="No"
              placement="rightTop"
              disabled={dataOne ? false : true}
              onConfirm={() => formRef.current.submit()}
            >
              <Button type="primary" disabled={dataOne ? false : true}>
                {dataOne && dataOne.welcome_reset_status
                  ? "Send Password Reset Link"
                  : "Send Invitation"}
              </Button>
            </Popconfirm>
          )}
        </Form.Item>
      </Form>
    );
  }
}

export default FormOne;
